// styles.js - Updated with editable code styles

import borderRadius from 'src/theme/core/borderRadius'

const styles = theme => ({
  // MEVCUT STİLLER - DEĞİŞTİRİLMEDİ
  container: {
    width: '440px',
    minWidth: '320px',
    maxWidth: '440px',
    padding: '20px',
    alignItems: 'center',
    gap: '20px',
    alignSelf: 'stretch',
    borderRadius: '16px',
    background: 'var(--mcg-white, #FFF)',
    boxShadow:
      '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
  },

  botMessageWrapper: {
    whiteSpace: 'pre-wrap',
    display: 'flex',
    padding: '10px 12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    alignSelf: 'stretch',
    borderRadius: '10px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },

  userMessageWrapper: {
    display: 'flex',
    whiteSpace: 'pre-wrap',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
    alignSelf: 'stretch',
    display: 'flex',
    width: '100%',
  },

  userMessage: {
    borderRadius: '10px',
    background: 'var(--mcg-lightblue, #E3F3FF)',
    display: 'flex',
    width: '360px',
    padding: '10px 12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
  },

  messagesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '440px',
    flex: '1 0 0',
    alignSelf: 'stretch',
  },

  messageText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },

  buildingText: {
    fontSize: '14px',
    color: '#6B7280',
    fontStyle: 'italic',
    marginTop: '8px',
    marginLeft: '0',
  },

  inputArea: {
    borderTop: '1px solid #E5E7EB',
    padding: '16px',
  },

  inputWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
    marginBottom: '12px',
  },

  textareaWrapper: {
    flex: 1,
    position: 'relative',
  },

  textarea: {
    width: '100%',
    height: '129px',
    padding: '12px',
    resize: 'none',
    outline: 'none',
    fontSize: '14px',
    lineHeight: '1.5',
    fontFamily: 'inherit',
    overflow: 'auto',
    boxSizing: 'border-box',
    borderRadius: '12px',
    border: '1px solid var(--AI, #50A7FF)',
    background: '#FFF',
    '&::placeholder': {
      color: '#9CA3AF',
    },
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a1a1a1',
    },
  },

  sendButton: {
    display: 'flex',
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #F4F6F8)',
    color: '#FFFFFF',
    right: '8px',
    border: 'none',
    bottom: '12px',
    cursor: 'pointer',
    height: '36px',
    zIndex: '1',
    position: 'absolute',
    minWidth: '36px',
    transition: 'all 0.2s ease-in-out',
  },

  warningText: {
    fontSize: '12px',
    color: '#6B7280',
    textAlign: 'center',
    display: 'block',
    margin: '0',
  },

  containerWithPreview: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    overflow: 'hidden',
  },

  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #E5E7EB',
    minHeight: '60px',
  },

  headerTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: '600',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
  },

  previewToggle: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    position: 'relative',
  },

  toggleLabel: {
    fontSize: '14px',
    fontWeight: '500',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
  },

  toggleHint: {
    fontSize: '12px',
    color: '#5B6576',
    fontFamily: 'Inter',
  },

  retryRow: {
    marginTop: '8px',
    whiteSpace: 'normal',
  },

  applyButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    backgroundColor: 'var(--AI, #50A7FF)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'Inter',
    marginLeft: '12px',
    '&:hover': {
      backgroundColor: '#3d8bfd',
      transform: 'translateY(-1px)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  },

  switch: {
    position: 'relative',
    display: 'inline-block',
    width: '50px',
    height: '24px',
    '& input': {
      opacity: 0,
      width: 0,
      height: 0,
    },
  },

  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#E5E7EB',
    transition: '0.3s',
    borderRadius: '24px',
    '&:before': {
      position: 'absolute',
      content: '""',
      height: '18px',
      width: '18px',
      left: '3px',
      bottom: '3px',
      backgroundColor: 'white',
      transition: '0.3s',
      borderRadius: '50%',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    },
  },

  'switch input:checked + slider': {
    backgroundColor: 'var(--AI, #50A7FF)',
  },

  'switch input:checked + slider:before': {
    transform: 'translateX(26px)',
  },

  // Main Content Area
  mainContent: {
    background: 'rgb(244, 246, 248)',
    gap: '20px',
    flex: '1',
    display: 'flex',

    overflow: 'hidden',
  },

  chatSection: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '440px',
    background: '#fff',
    borderRadius: '16px',
  },

  // Loading Container
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
  },

  previewSection: {
    padding: '16px',
    gap: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '320px',
    borderRadius: '16px',
    background: '#fff',
  },

  previewHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #E5E7EB',
  },

  previewTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: '600',
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
  },

  previewControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  previewButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 12px',
    backgroundColor: 'transparent',
    border: '1px solid #E5E7EB',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'Inter',
    '&:hover': {
      backgroundColor: '#F4F6F8',
    },
  },

  activeButton: {
    backgroundColor: 'var(--AI, #50A7FF)',
    color: '#ffffff',
    borderColor: 'var(--AI, #50A7FF)',
    '&:hover': {
      backgroundColor: '#3d8bfd',
    },
  },

  closeButton: {
    padding: '4px 8px',
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
    color: '#6B7280',
    '&:hover': {
      color: 'var(--mcg-dark, #002E47)',
    },
  },

  previewContent: {
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
  },

  previewIframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
  },

  codeContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },

  editableCodeArea: {
    flex: 1,
    width: '100%',
    border: '0',
    borderRadius: '8px',
    background: '#fff',
    color: '#637381',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
    resize: 'none',
    outline: 'none',
    overflowY: 'auto',
    '&:focus': {
      backgroundColor: '#ffffff',
      border: '0',
    },
    '&::placeholder': {
      color: '#9CA3AF',
      fontStyle: 'italic',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a1a1a1',
    },
  },

  codeStatus: {
    position: 'absolute',
    bottom: '8px',
    left: '8px',
    right: '8px',
    backgroundColor: '#FFF3CD',
    border: '1px solid #FFEAA7',
    borderRadius: '4px',
    padding: '6px 10px',
    fontSize: '11px',
    color: '#856404',
    fontFamily: 'Inter',
    textAlign: 'center',
    animation: '$fadeIn 0.3s ease-in-out',
  },

  '@keyframes fadeIn': {
    '0%': { opacity: 0, transform: 'translateY(10px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
  },

  codePreview: {
    height: '100%',
    margin: 0,
    backgroundColor: '#fff',
    overflow: 'auto',
    fontSize: '12px',
    fontFamily: 'Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    padding: '16px',
    '& code': {
      color: 'var(--mcg-dark, #002E47)',
    },
  },

  previewLoading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    color: '#6B7280',
    fontSize: '14px',
    fontFamily: 'Inter',
  },

  noContentMessage: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    color: '#9CA3AF',
    fontSize: '14px',
    fontFamily: 'Inter',
    textAlign: 'center',
  },

  loadingSpinner: {
    width: '24px',
    height: '24px',
    border: '2px solid #E5E7EB',
    borderTop: '2px solid var(--AI, #50A7FF)',
    borderRadius: '50%',
    animation: '$spin 1s linear infinite',
  },

  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },

  showPreviewButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 16px',
    backgroundColor: 'var(--AI, #50A7FF)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer',
    zIndex: 10,
    fontFamily: 'Inter',
    '&:hover': {
      backgroundColor: '#3d8bfd',
    },
  },

  streamingCursor: {
    animation: '$blink 1s infinite',
    color: 'var(--AI, #50A7FF)',
    fontSize: '16px',
    fontWeight: 'bold',
  },

  '@keyframes blink': {
    '0%, 50%': { opacity: 1 },
    '51%, 100%': { opacity: 0 },
  },

  '@media (max-width: 768px)': {
    container: {
      height: '100vh',
      width: '100%',
      borderRadius: '0',
      border: 'none',
    },

    messagesContainer: {
      width: '100%',
      padding: '16px',
    },
    botMessageWrapper: {
      maxWidth: '440px',
    },

    inputArea: {
      padding: '12px',
    },

    textarea: {
      padding: '12px 50px 12px 16px',
    },

    sendButton: {
      minWidth: '32px',
      height: '32px',
      padding: '6px',
    },

    containerWithPreview: {
      flexDirection: 'column',
      height: '100vh',
      borderRadius: '0',
    },

    headerSection: {
      padding: '12px 16px',
      minHeight: '50px',
    },

    headerTitle: {
      fontSize: '16px',
    },

    mainContent: {
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
    },

    chatSection: {
      flex: '1 1 60%',
      maxWidth: 'none',
      width: '100%',
      borderRight: 'none',
      borderBottom: '1px solid #E5E7EB',
      minWidth: 'auto',
    },

    previewSection: {
      flex: '1 1 40%',
      minWidth: 'auto',
      minHeight: '800px',
    },

    previewHeader: {
      padding: '12px 16px',
    },
    userMessage: {
      borderRadius: '10px',
      background: 'var(--mcg-lightblue, #E3F3FF)',
      display: 'flex',
      width: '100%',
      padding: '10px 12px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
    },
    previewToggle: {
      flexWrap: 'wrap',
      gap: '8px',
    },

    applyButton: {
      marginLeft: '0',
      marginTop: '8px',
      fontSize: '11px',
      padding: '4px 8px',
    },

    codePreview: {
      padding: '12px',
      fontSize: '11px',
    },

    codeStatus: {
      fontSize: '10px',
      padding: '4px 8px',
    },
  },

  '@media (max-width: 1024px) and (min-width: 769px)': {
    containerWithPreview: {
      height: '90vh',
    },

    mainContent: {
      flexDirection: 'column',
      overflowY: 'auto',
    },

    chatSection: {
      flex: '1 1 60%',
      maxWidth: 'none',
      width: '100%',
      borderRight: 'none',
      borderBottom: '1px solid #E5E7EB',
      minWidth: 'auto',
    },
    messagesContainer: {
      width: '100%',
      padding: '16px',
    },
    botMessageWrapper: {
      maxWidth: '440px',
    },
    previewSection: {
      flex: '1 1 40%',
      minWidth: 'auto',
      minHeight: '800px',
    },
    userMessage: {
      borderRadius: '10px',
      background: 'var(--mcg-lightblue, #E3F3FF)',
      display: 'flex',
      width: '100%',
      padding: '10px 12px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
    },
  },
})

export default styles
